import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Menu,
  MenuItem,
} from '@mui/material';
import {
  Home as HomeIcon,
  School as SchoolIcon,
  AccountCircle as AccountIcon,
} from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAppSelector } from '../../store/hooks';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentCourse = useAppSelector(state => state.progress.currentCourse);
  const courses = useAppSelector(state => state.courses);

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const isHomePage = location.pathname === '/' || location.pathname === '/courses';
  const courseName = currentCourse && courses[currentCourse] ? courses[currentCourse].title : '';

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <AppBar position='static' elevation={1}>
        <Toolbar>
          <IconButton
            edge='start'
            color='inherit'
            aria-label='home'
            onClick={() => navigate('/')}
            sx={{ mr: 2 }}
          >
            <SchoolIcon />
          </IconButton>

          <Typography variant='h6' component='div' sx={{ flexGrow: 1 }}>
            BrainSprout
            {!isHomePage && courseName && (
              <Typography component='span' variant='body2' sx={{ ml: 2, opacity: 0.8 }}>
                / {courseName}
              </Typography>
            )}
          </Typography>

          <Button
            color='inherit'
            startIcon={<HomeIcon />}
            onClick={() => navigate('/')}
            sx={{ mr: 1 }}
          >
            Courses
          </Button>

          <IconButton
            size='large'
            aria-label='account of current user'
            aria-controls='menu-appbar'
            aria-haspopup='true'
            onClick={handleMenu}
            color='inherit'
          >
            <AccountIcon />
          </IconButton>

          <Menu
            id='menu-appbar'
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={handleClose}>Profile</MenuItem>
            <MenuItem onClick={handleClose}>Settings</MenuItem>
            <MenuItem onClick={handleClose}>Help</MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>

      <Box component='main' sx={{ flexGrow: 1, bgcolor: 'background.default' }}>
        {children}
      </Box>

      <Box
        component='footer'
        sx={{
          py: 2,
          px: 2,
          mt: 'auto',
          backgroundColor: 'grey.100',
          textAlign: 'center',
        }}
      >
        <Typography variant='body2' color='text.secondary'>
          © 2024 BrainSprout Learning Platform
        </Typography>
      </Box>
    </Box>
  );
};

export default Layout;
